/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MetaIntegrationAdAccountData
 */
export interface MetaIntegrationAdAccountData {
    /**
     * 
     * @type {string}
     * @memberof MetaIntegrationAdAccountData
     */
    accountId?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaIntegrationAdAccountData
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MetaIntegrationAdAccountData
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MetaIntegrationAdAccountData
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof MetaIntegrationAdAccountData
     */
    timeZone?: string;
}

/**
 * Check if a given object implements the MetaIntegrationAdAccountData interface.
 */
export function instanceOfMetaIntegrationAdAccountData(value: object): value is MetaIntegrationAdAccountData {
    return true;
}

export function MetaIntegrationAdAccountDataFromJSON(json: any): MetaIntegrationAdAccountData {
    return MetaIntegrationAdAccountDataFromJSONTyped(json, false);
}

export function MetaIntegrationAdAccountDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetaIntegrationAdAccountData {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'] == null ? undefined : json['accountId'],
        'name': json['name'] == null ? undefined : json['name'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'timeZone': json['timeZone'] == null ? undefined : json['timeZone'],
    };
}

export function MetaIntegrationAdAccountDataToJSON(json: any): MetaIntegrationAdAccountData {
    return MetaIntegrationAdAccountDataToJSONTyped(json, false);
}

export function MetaIntegrationAdAccountDataToJSONTyped(value?: MetaIntegrationAdAccountData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accountId': value['accountId'],
        'name': value['name'],
        'enabled': value['enabled'],
        'currency': value['currency'],
        'timeZone': value['timeZone'],
    };
}

